import { render, staticRenderFns } from "./ContractFileSettting.vue?vue&type=template&id=38a3fbcc"
import script from "./ContractFileSettting.vue?vue&type=script&lang=js"
export * from "./ContractFileSettting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports